export default "__VITE_ASSET__tMLkZZvu__"